<h2 mat-dialog-title>Aircraft</h2>

<div mat-dialog-content class="dialog">
  <div>
    <form
      [formGroup]="form"
      (ngSubmit)="onSave()"
      style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px"
    >
      <mat-form-field appearance="outline">
        <mat-label>Code</mat-label>
        <input matInput formControlName="code" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Model</mat-label>
        <input matInput formControlName="model" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Condition</mat-label>
        <input matInput formControlName="condition" />
      </mat-form-field>
    </form>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()">Save</button>
</div>
